module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sugar Jamison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Sugar Jamison")]), _vm._v(" is a Southern belle trapped in a New Yorker's body. With a love of big hair and high heeled shoes, she spends her day at her very normal day job and night dreaming up sweet and sassy romances.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/o1y9iD/tc-custom/9781466826304.jpg?1731181197738",
      "alt": "This image is the cover for the book Gentlemen Prefer Curves"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gentlemen Prefer Curves\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v(" SOMETIMES SIZE "), _c('i', [_vm._v("DOES ")]), _vm._v("MATTER"), _c('br')]), _vm._v("Belinda Gordon thought she had it all-a great job, wonderful friends, a home of her own. She's even come to love her voluptuous body. But she still can't shake the feeling that something is missing. And then Carter Lancaster, aka Her Biggest Mistake, shows up in town, as irresistible as ever, and shakes up her entire world."), _c('br'), _c('br'), _c('b', [_vm._v("WHEN IT COMES TO LOVE"), _c('br')]), _vm._v("Carter never expected to find Belinda in town, looking as delicious as the day he married her five years ago-before she walked out on him after six weeks and a painful misunderstanding that included his baby daughter, Ruby. A quick divorce is the sensible option-but Carter can't let Belinda go now, not when he can see the family they could be. Love may be a curveball, but this time he's going to prove to Belinda that he can hit it out of the park... "), _c('i', [_vm._v("Gentlemen Prefer Curves ")]), _vm._v("is the third book in the Perfect Fit series"), _c('br'), _c('b', [_c('br'), _vm._v("Praise for Sugar Jamison's "), _c('i', [_vm._v("Dangerous Curves Ahead")])]), _c('br'), _vm._v("\"Laugh out loud funny and super sexy, with unique characters you can't help but love!\"-"), _c('i', [_vm._v("New York Times ")]), _vm._v("bestselling author Lori Foster")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0